import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobhimashankarcab() {



  const cardData =
  {
    keyword: 'Pune to Bhimashankar Cab ',
    heading: 'Sai Trupti Cabs: Pune to Bhimashankar Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Bhimashankar cab service for Jyotirlinga darshan, ensuring a smooth and stress-free journey for pilgrims and travelers. Our fleet includes well-maintained AC sedans, SUVs, Innova Crysta, and premium vehicles, all equipped with clean interiors and ample luggage space for a comfortable ride. Every trip is handled by a professional, background-verified driver who ensures timely pickup, safe driving on ghat roads, and a pleasant travel experience throughout the journey. We provide flexible options like one way cab Pune to Bhimashankar, round trip taxi, and one day darshan packages at transparent and affordable fares with no hidden charges. With 24x7 online cab booking, instant confirmation, and dedicated customer support, Sai Trupti Cabs makes your Bhimashankar temple trip convenient, safe, and hassle-free every time.',

    top: 'Top Places to Visit in Bhimashankar with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga Temple",
    "description": "Bhimashankar Jyotirlinga Temple is one of the twelve sacred Jyotirlingas of Lord Shiva and a major pilgrimage site in Maharashtra. Nestled in the Sahyadri ranges, the temple showcases exquisite Nagara-style architecture with intricate carvings and ancient stonework. According to legend, this is where Lord Shiva manifested as Bhimashankar to defeat the demon Tripurasura. The serene surroundings and constant chanting create a deeply spiritual atmosphere. The temple beautifully blends divine energy with the raw beauty of nature."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Bhimashankar Wildlife Sanctuary is a biodiversity hotspot spread across dense forests of the Western Ghats. Home to the rare Indian giant squirrel (Shekru), it also shelters leopards, deer, and numerous bird species. The lush greenery, misty trails, and flowing streams make it a paradise for nature lovers. The sanctuary plays a vital role in conserving endangered flora and fauna. Exploring it feels like stepping into an untouched natural world."
  },
  {
    "title": "Gupt Bhimashankar",
    "description": "Gupt Bhimashankar is a hidden and lesser-known sacred spot located deep within the forest. It is believed that Lord Shiva appeared here in a subtle form before manifesting at the main temple. A small natural Shivling near a flowing stream enhances the spiritual charm of the place. The peaceful surroundings make it ideal for meditation and quiet prayer. It offers a more intimate and serene spiritual experience."
  },
  {
    "title": "Hanuman Lake",
    "description": "Hanuman Lake is a calm and scenic water body near the Bhimashankar temple complex. Surrounded by forests and hills, it provides a peaceful spot for relaxation and reflection. Devotees often rest here after temple darshan, enjoying the cool breeze and tranquil views. The lake adds to the overall serenity of Bhimashankar. It’s a perfect place to pause and absorb nature’s calm."
  },
  {
    "title": "Nagphani Point",
    "description": "Nagphani Point, also known as the Cobra’s Hood viewpoint, offers breathtaking panoramic views of the surrounding valleys and mountains. The viewpoint gets its name from its snake-hood-like rock formation. Especially mesmerizing during monsoon, the area is often covered in mist and clouds. It’s a favorite spot for photographers and nature enthusiasts. The view here captures the wild beauty of the Sahyadris."
  },
  {
    "title": "Gupt Bhima River Origin",
    "description": "Bhimashankar is believed to be the origin of the sacred Bhima River, which flows through Maharashtra and Karnataka. The river begins as a small stream amid dense forests, symbolizing purity and life. Devotees consider its waters holy and spiritually cleansing. The natural setting around the origin is quiet and untouched. It highlights the deep connection between nature and spirituality at Bhimashankar."
  },
  {
    "title": "Sahyadri Trekking Trails",
    "description": "Bhimashankar offers several scenic trekking routes through dense forests, steep climbs, and rocky paths. Popular treks like the Ganesh Ghat and Shidi Ghat attract adventure enthusiasts. Trekking here combines physical challenge with stunning natural beauty. Along the way, trekkers encounter waterfalls, wildlife, and breathtaking viewpoints. These trails make Bhimashankar a perfect blend of devotion and adventure."
  },
  {
    "title": "Bhimashankar Viewpoints",
    "description": "Multiple viewpoints around Bhimashankar provide sweeping views of deep valleys, green plateaus, and distant hills. Sunrise and sunset are particularly magical, painting the landscape in golden hues. The mist-covered terrain adds a mystical charm to the scenery. These viewpoints offer moments of peace and awe. They perfectly complement the spiritual journey with visual grandeur."
  },
  {
    "title": "Village Life Around Bhimashankar",
    "description": "The small villages surrounding Bhimashankar offer a glimpse into simple rural life in the Western Ghats. Local communities live in harmony with nature, practicing traditional farming and forest-based livelihoods. Visitors can experience warm hospitality and authentic Maharashtrian culture. The calm pace of life enhances the spiritual and natural experience. It adds a human touch to Bhimashankar’s sacred landscape."
  },
  {
    "title": "Monsoon Experience at Bhimashankar",
    "description": "During monsoon, Bhimashankar transforms into a lush green paradise with flowing waterfalls, misty forests, and cool weather. The rains enhance the beauty of the sanctuary and surrounding hills. Though travel requires caution, the experience is truly magical. Nature appears at its most vibrant and alive. Monsoon visits offer an unforgettable and refreshing escape into nature and devotion."
  }
],



  "services": [
    {
      "name": "Pune to Bhimashankar Cab",
      "description": "Reliable cab service from Pune to Bhimashankar covering approximately 110–130 km through scenic hill and forest routes. This service offers AC and non-AC vehicles, experienced drivers familiar with ghat roads, flexible pickup points, luggage assistance, and transparent pricing. Ideal for pilgrims, families, and weekend travelers visiting the Bhimashankar Jyotirlinga."
    },
    {
      "name": "Taxi from Pune to Bhimashankar",
      "description": "Comfortable taxi service from Pune to Bhimashankar providing direct, point-to-point travel. Includes well-maintained vehicles, professional chauffeurs skilled in mountain driving, rest stops on request, and safe travel suitable for senior citizens and religious tourists."
    },
    {
      "name": "Bhimashankar to Pune Cab",
      "description": "Return cab service from Bhimashankar to Pune with flexible pickup timing after darshan or sightseeing. Features clean AC vehicles, experienced drivers, luggage support, and smooth travel back to Pune with transparent cab charges."
    },
    {
      "name": "Pune to Bhimashankar Taxi Service",
      "description": "Dedicated taxi service from Pune to Bhimashankar designed for temple visits and religious tours. Offers comfortable seating, AC travel, knowledgeable drivers, assistance for darshan schedules, and reliable long-distance service."
    },
    {
      "name": "Pune to Bhimashankar Cab Booking",
      "description": "Easy cab booking service from Pune to Bhimashankar with advance reservations, multiple vehicle options, instant confirmation, and flexible travel plans. Ideal for planned darshan trips, weekend getaways, and group travel."
    },
    {
      "name": "Pune to Bhimashankar One Day Trip Cab",
      "description": "One-day trip cab package from Pune to Bhimashankar suitable for early morning departures and same-day return. Includes driver allowance, sightseeing time, temple visit support, and cost-effective package pricing."
    },
    {
      "name": "Pune to Bhimashankar Temple Cab",
      "description": "Temple cab service from Pune to Bhimashankar focused on religious comfort and convenience. Perfect for devotees visiting the Bhimashankar Mahadev temple, offering safe driving on forest routes, patient drivers, and flexible halt times."
    },
    {
      "name": "Pune to Bhimashankar Jyotirlinga Cab",
      "description": "Special Jyotirlinga cab service from Pune to Bhimashankar for pilgrims seeking a peaceful and hassle-free darshan journey. Includes AC vehicles, experienced chauffeurs, and comfortable travel through hilly terrain."
    },
    {
      "name": "Pune to Bhimashankar Darshan Cab",
      "description": "Darshan-focused cab service from Pune to Bhimashankar with early pickup options, temple-friendly schedules, and ample waiting time. Suitable for families, elderly devotees, and group pilgrimages."
    },
    {
      "name": "Pune to Bhimashankar Religious Tour Taxi",
      "description": "Religious tour taxi from Pune to Bhimashankar designed for spiritual travelers. Offers calm, comfortable travel, experienced drivers, clean vehicles, and reliable service for temple visits and spiritual retreats."
    },
    {
      "name": "Pune to Bhimashankar Innova Cab",
      "description": "Spacious Innova cab service from Pune to Bhimashankar providing superior comfort, ample legroom, and luggage space. Ideal for families and groups traveling together on religious or sightseeing trips."
    },
    {
      "name": "Pune to Bhimashankar Innova Crysta Cab",
      "description": "Premium Innova Crysta cab from Pune to Bhimashankar featuring luxury seating, enhanced suspension for ghat roads, AC comfort, and professional chauffeurs for a smooth and premium travel experience."
    },
    {
      "name": "Pune to Bhimashankar Ertiga Cab",
      "description": "Ertiga cab service from Pune to Bhimashankar suitable for small groups and families. Offers AC comfort, economical pricing, reliable performance on hilly routes, and professional drivers."
    },
    {
      "name": "Pune to Bhimashankar Sedan Cab",
      "description": "Sedan cab service from Pune to Bhimashankar ideal for couples and small families. Provides smooth rides, AC/non-AC options, experienced drivers, and affordable cab fares."
    },
    {
      "name": "Pune to Bhimashankar SUV Taxi",
      "description": "SUV taxi service from Pune to Bhimashankar offering better ground clearance, powerful performance, and enhanced safety on forest and ghat roads. Suitable for comfortable travel in all seasons."
    },
    {
      "name": "Pune to Bhimashankar AC Cab",
      "description": "AC cab service from Pune to Bhimashankar ensuring cool, comfortable, and relaxed travel even during long uphill drives. Includes clean interiors, professional drivers, and transparent pricing."
    },
    {
      "name": "Pune to Bhimashankar Tempo Traveller",
      "description": "Tempo Traveller service from Pune to Bhimashankar ideal for group pilgrimages and religious tours. Offers spacious seating, AC options, ample luggage space, and cost-effective group travel."
    },
    {
      "name": "Pune to Bhimashankar Wildlife Sanctuary Cab",
      "description": "Cab service from Pune to Bhimashankar Wildlife Sanctuary perfect for nature lovers and sightseeing travelers. Includes experienced drivers familiar with forest routes, safe driving practices, and flexible travel plans."
    },
    {
      "name": "Pune to Bhimashankar Forest Route Taxi",
      "description": "Forest route taxi from Pune to Bhimashankar providing a scenic and safe journey through lush greenery. Ideal for travelers seeking a peaceful drive with skilled drivers experienced in hilly terrain."
    },
    {
      "name": "Pune to Bhimashankar Weekend Trip Cab",
      "description": "Weekend trip cab from Pune to Bhimashankar designed for short getaways combining temple visits and nature exploration. Offers flexible scheduling, comfortable vehicles, and economical packages."
    },
    {
      "name": "Pune to Bhimashankar Sightseeing Taxi",
      "description": "Sightseeing taxi service from Pune to Bhimashankar covering temple visits, viewpoints, and nearby attractions. Includes patient drivers, flexible halt options, and comfortable all-day travel."
    }
  ],
  "tableData": [
    ["Pune to Bhimashankar Cab", "Taxi from Pune to Bhimashankar"],
    ["Bhimashankar to Pune Cab", "Pune to Bhimashankar Taxi Service"],
    ["Pune to Bhimashankar Cab Booking", "Pune to Bhimashankar One Day Trip Cab"],
    ["Pune to Bhimashankar Temple Cab", "Pune to Bhimashankar Jyotirlinga Cab"],
    ["Pune to Bhimashankar Darshan Cab", "Pune to Bhimashankar Religious Tour Taxi"],
    ["Pune to Bhimashankar Innova Cab", "Pune to Bhimashankar Innova Crysta Cab"],
    ["Pune to Bhimashankar Ertiga Cab", "Pune to Bhimashankar Sedan Cab"],
    ["Pune to Bhimashankar SUV Taxi", "Pune to Bhimashankar AC Cab"],
    ["Pune to Bhimashankar Tempo Traveller", "Pune to Bhimashankar Wildlife Sanctuary Cab"],
    ["Pune to Bhimashankar Forest Route Taxi", "Pune to Bhimashankar Weekend Trip Cab"],
    ["Pune to Bhimashankar Sightseeing Taxi", ""]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Pune to Bhimashankar Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs offers reliable and comfortable cab services from Pune to Bhimashankar — ideal for pilgrimage trips, family travel, and temple visits."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our one-way fares from Pune to Bhimashankar start from approximately ₹2,500–₹3,800 for sedans, with SUVs and premium car options available at reasonable rates."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, tempo travellers, or premium cars to suit your group size, luggage needs, and comfort preferences for the Pune → Bhimashankar route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are experienced with ghat roads and the Pune to Bhimashankar route, ensuring a safe and smooth journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups anywhere in Pune and drop-offs directly near the Bhimashankar temple and surrounding accommodations."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized, and equipped with essential amenities for a comfortable and hygienic hill and temple journey."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, travel assistance, or route planning for your Pune to Bhimashankar cab trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Bhimashankar cab easily through a call, WhatsApp, or our website — with instant confirmation and quick vehicle dispatch."
  }
]



  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Bhimashankar cab services?',
    answer: 'Yes, Sai Trupti Cabs provides reliable and affordable cab services from Pune to Bhimashankar for one-way, round-trip, and pilgrimage travel.',
  },
  {
    question: 'How can I book a Pune to Bhimashankar cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Bhimashankar cab through our website, mobile app, WhatsApp, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Pune to Bhimashankar?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, tempo travellers, and luxury cabs for Pune to Bhimashankar travel.',
  },
  {
    question: 'Are the drivers experienced for Pune to Bhimashankar trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in hill driving and pilgrimage routes.',
  },
  {
    question: 'Can I hire a cab from Pune to Bhimashankar for a same-day return trip?',
    answer: 'Yes, we offer same-day return and round-trip cab options for Pune to Bhimashankar.',
  },
  {
    question: 'Is the Pune to Bhimashankar cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Pune to Bhimashankar trips.',
  },
  {
    question: 'What are the Pune to Bhimashankar cab fares?',
    answer: 'Our cab fares start from approximately ₹2,500 for sedans and ₹3,800–₹5,500 for SUVs and premium vehicles, depending on travel requirements.',
  },
  {
    question: 'What payment options are accepted for Pune to Bhimashankar cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Bhimashankar cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures.',
  },
  {
    question: 'Is customer support available during the Pune to Bhimashankar cab ride?',
    answer: 'Yes, our 24×7 customer support team is available throughout your Pune to Bhimashankar cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Mahesh Pawar',
    feedback: 'Booked a Pune to Bhimashankar cab with Sai Trupti Cabs. Safe driving on ghat roads and very comfortable journey.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Kulkarni',
    feedback: 'Excellent cab service for Pune to Bhimashankar. On-time pickup and very polite driver.',
    rating: 5,
  },
];















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhimashankar Darshan Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-bhimashankar-cab.jpg",
  "description": "Sai Trupti Cabs offers Pune to Bhimashankar cab service for Jyotirlinga darshan with one day trip packages. Book Innova Crysta, Ertiga, sedan and SUV cabs for safe, comfortable and affordable pilgrimage travel with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "9780"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-bhimashankar-cab",
    "itemCondition": "https://schema.org/NewCondition"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune to Bhimashankar Cab | Jyotirlinga Darshan Taxi ₹2499 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Bhimashankar cab for Jyotirlinga darshan at ₹2499 with Sai Trupti Cabs. One day trip, Innova Crysta, Ertiga, sedan & SUV available. Safe and comfortable pilgrimage cab service." 
  />

  <meta 
    name="keywords" 
    content="pune to bhimashankar cab, bhimashankar darshan cab pune, pune to bhimashankar taxi, bhimashankar jyotirlinga cab, pune to bhimashankar one day trip cab, pune to bhimashankar taxi fare, pune to bhimashankar innova crysta, bhimashankar ertiga cab, bhimashankar sedan cab, cheap bhimashankar cab pune, best cab service bhimashankar darshan, bhimashankar temple cab booking pune" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/90.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobhimashankarcab;